import { createAction, createAsyncThunk } from "@reduxjs/toolkit"

import { ApiNotificacoes } from "../../service/api/ApiNotificacao";
import { ErrosUtils } from "util/ErrosUtils";
import { ItemListaNotificacoes } from "view/extrair/Notificacao/model/ItemListaNotificacoes";
import { AlertaAExibir } from "../../model/NotificacaoAExibir";

class NotificacoesSseAction {
  static iniciar = () => {
    return NotificacoesSseAction._iniciarConexao;
  }

  static _iniciarConexao = createAction('Notificacoes/sse/conexao/iniciar');
  static _definirComoConectado = createAction('Notificacoes/sse/conexao/conectado');
  static _adicionarNotificacao = createAction<ItemListaNotificacoes>('Notificacoes/sse/notificacao/adicionar');
}


interface MarcarComoProps {
  item: ItemListaNotificacoes;
  visualizado: boolean;
}

class ListaNotificacaoAction {
  static toggleVisualizado = (item: ItemListaNotificacoes) => ListaNotificacaoAction._marcarComo({item: item, visualizado: !item.visualizado});

  static readonly exibirAlerta = createAction<AlertaAExibir>('Notificacoes/lista/adicionar');

  static readonly _marcarComo = createAsyncThunk(
    'Notificacoes/lista/item/marcarComo',
    async ({item, visualizado}: MarcarComoProps, {rejectWithValue}) => {
      try {
        return await ApiNotificacoes.marcarComo(item, visualizado);
      } catch (e) {
        return rejectWithValue(ErrosUtils.converterErroAxiosParaErroSistema(e));
      }
    }
  );

  static readonly iniciar = createAsyncThunk(
    'Notificacoes/lista/carregar',
    async (it: void, {rejectWithValue}) => {
      try {
        return await ApiNotificacoes.getAll();
      } catch (e) {
        return rejectWithValue(ErrosUtils.converterErroAxiosParaErroSistema(e));
      }
    }
  );
}



export class NotificacoesAction {
  static readonly sse = NotificacoesSseAction;
  static readonly lista = ListaNotificacaoAction;
}

